export const PridobivanjeStoritevSmarTv = {
  methods: {
    GetStoritevSmartTv (prenParametri) {
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('grupiranjeStoritev=1')
      this.clientAgent.postWsRequest(
        this,
        '/prikljucek/storitve/naborTvStoritev?',
        param,
        prenParametri,
        'SetTvProgrami',
        'ErrTvProgrami')
    },
    SetTvProgrami (podatki, prenParametri) {
      let vmesnik = prenParametri.vmesnik
      vmesnik.SetSmartTvData(prenParametri, podatki.smartTv)
    },
    ErrTvprogrami (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/NarociTelevizija/NaborStoritevTvSmart.js